import React, { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import APP_ROUTES from "src/routes/routes";
import LoadingWrapper from "src/components/Common/Table/Loading";
import useGetSequenceDetail from "src/components/Sequence/detail/useGetSequenceDetail";
import SequenceDetailForm from "src/components/Sequence/form/SequenceDetailForm";
import routeGuard from "src/Hooks/routeGuard";
import { RESOURCE_TYPE, ROLES } from "src/constant/common";
import useEditSequenceDetail from "src/components/Sequence/detail/useEditSequenceDetail";

export const FORM_NAME = {
  MAIN: {
    ID: "id",
    USER_INPUT_ID: "user_input_id",
    NOTE: "notes",
    NAME: "name",
    INSTANCE_ID: "yamcs_package_id",
    INSTANCE_NAME: "project_instance_name",
    TEST_PACKAGE_ID: "test_package_id",
    LINKED_INSTANCE: "combination_id",
    DATA_SOURCE: "datasource",
    SOURCE: "source",
    DEVICE: "device",
    TIME_SPANS: "time_spans",
    UPLOAD_TIME: "created_at",
    LAST_EDITOR: "updated_by",
    START_TIME: "start_time",
    END_TIME: "end_time",
    START_TIMESTAMP: "start_timestamp",
    END_TIMESTAMP: "end_timestamp",
    INCREMENT_ID: "increment_id",
    HOSTNAME: "hostname",
  },
  SEQUENCE_DATA_SUMMARY: {},
  SEQUENCE_FILE_HISTORY: {},
};

const SequenceDetail = () => {
  const { id } = useParams();
  let [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const condition = searchParams.get("condition");
  const instanceId = searchParams.get("instanceId");
  const testPackageId = searchParams.get("testPackageId");

  const { data, isLoading: isLoadingSequenceDetail } = useGetSequenceDetail(id);

  const getRedirectURL = useCallback(() => {
    const baseUrl = `${APP_ROUTES.SEQUENCES}?id=${id}`;
    const queryParams = [
      page && `page=${page}`,
      condition && `condition=${condition}`,
      instanceId && `instanceId=${instanceId}`,
      testPackageId && `testPackageId=${testPackageId}`,
    ].filter(Boolean);

    return queryParams.length ? `${baseUrl}&${queryParams.join("&")}` : baseUrl;
  }, [id, page, condition, instanceId, testPackageId]);

  const { submitData } = useEditSequenceDetail();

  return (
    <>
      <LoadingWrapper loading={isLoadingSequenceDetail} customClass="loading-detail-page">
        <SequenceDetailForm submitData={submitData} data={data} getRedirectURL={getRedirectURL} />
      </LoadingWrapper>
    </>
  );
};

export default routeGuard(SequenceDetail, RESOURCE_TYPE.PROJECT_INSTANCE, ROLES.SERVICE_ADMIN || ROLES.ADMIN || ROLES.EDITOR);
